import { Spinner, Wrapper } from 'components';

import styles from './styles.module.scss';
import { PageWrapper } from 'pages/Workshop/PageWrapper';
import { TasksList } from 'pages/Workshop/Transactions/TransactionTasks/components/Tasks/components';
import Task from '../../../Transactions/TransactionTasks/components/Task';
import { TaskTabs } from '../TaskTabs';

export const TasksContent = (props) => {
  const { isPending, showListView } = props;

  if (isPending) return <Spinner loaderClassName={styles.loader} />;

  if (showListView) {
    return (
      <PageWrapper className={styles.taskPageWrapper} isHideFooter isContainer={false}>
        <Wrapper isPending={isPending}>
          <TasksList showSelectAll isAggregatedTasks {...props} />
          <Task />
        </Wrapper>
      </PageWrapper>
    );
  }
  return (
    <div className={styles.tasksContent}>
      <TaskTabs {...props} />
      <Task />
    </div>
  );
};
